export const MODULE_NAME = 'rent';
